import axios from 'axios';

export const getQuote = ({
  data,
  token,
  variant,
  quoteNumber,
}) => {
  const bodyData = {
    parameters: data,
    authenticity_token: token,
    variant_id: variant,
  };

  if (quoteNumber && quoteNumber !== '') {
    return axios.put(`${Spree.routes.product_quote_url}/${quoteNumber}.json`, bodyData);
  }

  return axios.post(`${Spree.routes.product_quote_url}.json`, bodyData);
};

export const emailQuote = ({ data, token }) => {
  const bodyData = {
    ...data,
    authenticity_token: token,
  };
  return axios.post(`${Spree.routes.product_quote_email_url}.json`, bodyData);
};
